module.exports = __webpack_public_path__ + "static/media/look_at.05135ffa.jpg";